import { render } from "./BannersView.vue?vue&type=template&id=6ef8790f&scoped=true&ts=true"
import script from "./BannersView.vue?vue&type=script&lang=ts"
export * from "./BannersView.vue?vue&type=script&lang=ts"

import "./BannersView.vue?vue&type=style&index=0&id=6ef8790f&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ef8790f"]])

export default __exports__